import { Theme } from '@simplybenefits/sb-ui-library';

const colors = Theme.colors;
const fonts = Theme.fonts;

// This file is for a reusable grouping of Theme items.

const globalStyles = {
    cardBlock: {
        '&:hover': {
            borderLeft: `${ colors.mediumBlue } solid 5px`
        },
        backgroundColor: colors.surface,
        borderLeft: `${ colors.surface } solid 5px`,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        cursor: 'pointer',
        height: 'auto',
        marginBottom: '8px',
        minHeight: '90px',
        padding: '20px 30px 2px 25px',
        position: 'relative'
    },
    cardTitle: {
        display: 'block',
        fontFamily: fonts.type.base,
        fontSize: '16px',
        lineHeight: '24px',
        margin: '0',
        padding: '0',
        textTransform: 'capitalize'
    },
    container: {
        backgroundColor: colors.surface,
        height: 'auto',
        margin: '0',
        minHeight: '100vh',
        padding: '30px',
        paddingBottom: '1px',
        paddingTop: '30px',
        position: 'relative',
        width: '100%'
    },
    content: {
        '@media (max-width: 1500px)': {
            width: '90%'
        },
        '@media (max-width: 600px)': {
            width: '95%'
        },
        '@media (max-width: 400px)': {
            width: '98%'
        },
        margin: '20px auto',
        width: '75%'
    },
    contentSmall: {
        '@media (max-width: 2000px)': {
            width: '60%'
        },
        '@media (max-width: 1500px)': {
            width: '75%'
        },
        '@media (max-width: 600px)': {
            width: '95%'
        },
        '@media (max-width: 400px)': {
            width: '98%'
        },
        margin: '20px auto',
        width: '45%'
    },
    contentBlock: {
        backgroundColor: colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        display: 'block',
        margin: 'auto auto 30px auto',
        padding: '30px',
        position: 'relative'
    },
    contentMargin: {
        marginTop: '30px'
    },
    singleLineCard: {
        cursor: 'default',
        marginBottom: '0',
        minHeight: '30px',
        padding: '10px'
    },
    expansionRoot: {
        boxShadow: 'none'
    },
    expansionSummary: {
        padding: '0'
    },
    form: {
        backgroundColor: colors.surface,
        boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
        margin: '20px auto 50px auto',
        padding: '20px',
        position: 'relative',
        width: 384,
        maxWidth: '100%'
    },
    logo: {
        display: 'block',
        margin: '0 auto 10px',
        maxHeight: 220,
        maxWidth: 320,
        paddingBottom: 25,
        paddingTop: 35
    },
    memberCard: {
        cursor: 'default',
        marginBottom: '0',
        minHeight: '50px',
        padding: '10px 10px 10px 10px'
    },
    scrollbar: {
        '&::-webkit-scrollbar': {
            height: '15px',
            width: '15px'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: colors.surface,
            borderRadius: '10px',
            boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: colors.backgroundGrey,
            borderRadius: '10px',
            boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
        }
    },
    stepper: {
        width: 480,
        margin: "0 auto 50px auto",
        position: "relative",
        padding: 30,
        backgroundColor: colors.surface,
        boxShadow: "0 1px 2px rgba(0,0,0,.15)",
        maxWidth: '100%',
        '@media (max-width: 500px)': {
            padding: 0,
            boxShadow: 'none'
        }
    },
    stepperBackBtn: {
        float: 'left'
    },
    stepperBtnContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '20px'
    },
    stepperFinishBtn: {
        float: 'right'
    },
    stepperForm: {
        backgroundColor: colors.surface,
        boxShadow: 'none',
        margin: '0 auto 0 auto',
        padding: '0 0 20px 0',
        position: 'relative',
        width: 384,
        maxWidth: '100%'
    },
    stepperNextBtn: {
        float: 'right',
        marginRight: '5px !important'
    },
    table: {
        display: 'block',
        overflowX: 'auto',
        paddingBottom: '20px',
        width: '100%'
    },
    tableRow: {
        '&:nth-of-type(odd)': {
            backgroundColor: colors.backgroundGrey
        }
    },
    tableHeading: {
        fontFamily: fonts.type.medium
    },
    tabRoot: {
        '&:focus': {
            color: colors.skyBlue
        },
        '&:hover': {
            color: colors.skyBlue,
            opacity: 1
        },
        fontSize: 16,
        textTransform: 'initial'
    },
    tabSelected: {
        color: colors.skyBlue
    },
    tabsIndicator: {
        backgroundColor: colors.mediumBlue
    },
    title: {
        color: colors.mainTextGrey,
        fontFamily: fonts.type.medium,
        fontSize: '20px',
        lineHeight: '40px',
        margin: 0,
        textAlign: 'center'
    },
    titleDivider: {
        borderBottom: `1px solid ${ colors.borderGrey }`,
        color: colors.mediumDarkGrey,
        fontFamily: fonts.type.base,
        fontSize: '16px',
        lineHeight: '40px',
        marginTop: '20px',
        width: '100%'
    },
    blockRow: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        backgroundColor: Theme.colors.surface,
        flexDirection: 'row',
        height: 60,
        marginBottom: 5,
        cursor: 'pointer'
    },

    forgotBtn: {
        color: colors.mediumDarkGrey,
        fontFamily: fonts.type.medium,
        fontSize: '12px',
        paddingBottom: '1px',
        paddingLeft: '0',
        paddingRight: '0',
        paddingTop: '0',
        textTransform: 'capitalize'
    },
    inputWithAdornment: {
        width: '100%'
    }
};

export default globalStyles;